import { useTranslation } from "react-i18next";

import { IconTool02 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";
import { ROUTES } from "@constants/routes";

const { INVENTORY } = ROUTES;

const { MAINTENANCE } = INVENTORY;

export default function CreateMaintenanceHeader() {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      icon: <IconTool02 fill="dark" size="20" />,
    },
    {
      label: t("INVENTORY_MAINTENANCE.BREADCRUMBS.FIRST_STEP"),
      link: MAINTENANCE,
    },
    {
      label: t("INVENTORY_MAINTENANCE.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const headerText = {
    header: t("INVENTORY_MAINTENANCE.CREATE_HEADER"),
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
}
